/* eslint-disable import/no-unresolved, import/extensions */
import { hints as createHints } from 'driver.js/hints';
/* eslint-enable import/no-unresolved, import/extensions */

import { getFeature } from '../registry';
import { isHintSetDismissed, markHintSetDismissed, isTourDismissed } from '../storage';

let activeHints = null;
let activeHintSetId = null;

export function isHintActive() {
  return Boolean(activeHints && activeHints.isVisible());
}

function destroyActiveHints() {
  if (!activeHints) return;
  try {
    activeHints.hide();
  } catch (error) {
    // ignore
  }
  activeHints = null;
  activeHintSetId = null;
}

function hintItemsValidos(feature, ctx = {}) {
  const items = typeof feature.hints === 'function' ? feature.hints(ctx) : feature.hints || [];
  return items.filter(item => {
    if (!item.element) return true;
    if (typeof item.element === 'string') {
      return Boolean(document.querySelector(item.element));
    }
    return true;
  });
}

/**
 * Exibe beacons de hint se o conjunto ainda não foi visto e as condições forem atendidas.
 * @returns {boolean}
 */
export function showHintSet(hintSetId, userId, ctx = {}) {
  const feature = getFeature(hintSetId);
  if (!feature || feature.kind !== 'hint' || userId == null) return false;
  if (isHintSetDismissed(userId, feature.id, feature.version)) return false;

  const requires = feature.requires || [];
  const requirementsOk = requires.every(requiredId => {
    const required = getFeature(requiredId);
    if (!required) return false;
    if (required.kind === 'hint') {
      return isHintSetDismissed(userId, required.id, required.version);
    }
    return isTourDismissed(userId, required.id, required.version);
  });
  if (!requirementsOk) return false;

  if (typeof feature.canStart === 'function' && !feature.canStart(ctx)) return false;

  const validos = hintItemsValidos(feature, ctx);
  if (!validos.length) return false;

  destroyActiveHints();

  const pendingIds = new Set(validos.map(item => item.id));

  activeHints = createHints({
    buttonText: 'Entendi',
    hints: validos,
    onDismiss: (_element, hint) => {
      if (hint?.id != null) pendingIds.delete(hint.id);
      if (pendingIds.size === 0) {
        markHintSetDismissed(userId, feature.id, feature.version);
        destroyActiveHints();
      }
    },
  });

  activeHintSetId = feature.id;
  activeHints.show();
  return true;
}

export function hideActiveHints() {
  destroyActiveHints();
}

export function refreshActiveHints() {
  if (activeHints && activeHintSetId) {
    try {
      activeHints.refresh();
    } catch (error) {
      // ignore
    }
  }
}
